module.exports = __webpack_public_path__ + "static/media/left_layout_image_Car_M.ca0911d9.svg";